import { tNotificationsContext } from './Notification.types.ts';
import React from 'react';

const initialState: tNotificationsContext = {
  currentNotifications: null,
  setCurrentNotifications: () => {
    return null;
  },
  closeNotification: async () => {
    return;
  },
};

export const NotificationContext = React.createContext(initialState);

export const useNotificationsContext = (): tNotificationsContext =>
  React.useContext(NotificationContext);
